module.exports = __webpack_public_path__ + "static/image3-18ae047e24e6d89dff9f2fb424fc0473.jpg";